import {
  BLOG,
  BLOG_NEWS,
  BLOG_NUTRITION,
  BLOG_SKINCARE,
  BLOG_STUDIES,
  HOME,
  PRODUCTS,
  SHOP,
  SKINCARE_HOME,
  SKINCARE_PRODUCTS,
} from 'lib/constants/routes';

const BLOG_LISTINGS = new Set([
  BLOG,
  BLOG_NEWS,
  BLOG_NUTRITION,
  BLOG_SKINCARE,
  BLOG_STUDIES,
]);

export const getPageType = (url: string) => {
  const { pathname } = new URL(url, 'https://placeholder.invalid');
  const path = pathname.replace(/\/+$/, '') || HOME;

  if (path === HOME || path === SKINCARE_HOME) return 'home';
  if (
    path.startsWith(`${PRODUCTS}/`) ||
    path.startsWith(`${SKINCARE_PRODUCTS}/`)
  )
    return 'pdp';
  if (path.includes(SHOP)) {
    return 'plp';
  }
  if (BLOG_LISTINGS.has(path)) return 'blog';
  if (path.startsWith(`${BLOG}/`)) return 'article';
  return 'page';
};
